import { PlusOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
const { Text, Title } = Typography;

interface IAirExchangeEmpty {
  setOpenModal: (value: boolean) => void;
}

export const AirExchangeEmpty: React.FC<IAirExchangeEmpty> = ({
  setOpenModal,
}) => {
  return (
    <div className='h-full p-6 overflow-auto'>
      <div className='bg-white p-6 h-full flex text-center items-center justify-center'>
        <div className='max-w-[800px] flex flex-col gap-2.5 items-center'>
          <Title level={5}>
            Создайте свой первый расчет воздухообмена помещений
          </Title>
          <Text>
            Добро пожаловать в модуль "Таблица Воздухообмена". Модуль позволяет
            импортировать данные из файлов Excel, определять необходимый
            воздухообмен для различных типов помещений, автоматически
            генерировать и скачивать таблицу воздухообменов, а также получать
            быстрый доступ к встроенному "Справочнику Воздухообмена" прямо в
            интерфейсе модуля.
          </Text>

          <Button
            className='mt-1'
            type='primary'
            onClick={() => setOpenModal(true)}
            icon={<PlusOutlined />}
          >
            Создать
          </Button>
        </div>
      </div>
    </div>
  );
};
